import PagesController from 'controllers/PagesController';
import ComponentsManager from "controllers/ComponentsManager";
import Services from './Services';
import ServicesHeader from './ServicesHeader';
import ServicesImagesConseil from './ServicesImagesConseil';
import ServicesImagesDesign from './ServicesImagesDesign';
import ServicesImagesDevelopment from "./ServicesImagesDevelopment";
import ServicesImagesMonitoring from "./ServicesImagesMonitoring";
import ServicesImagesSEO from "./ServicesImagesSEO";
import TransitionServices from "./TransitionServices";


export default new class {
	constructor() {
		PagesController.addPage('services', Services);
		ComponentsManager.register('services_header', ServicesHeader);
		ComponentsManager.register('services_image_conseil', ServicesImagesConseil);
		ComponentsManager.register('services_image_design', ServicesImagesDesign);
		ComponentsManager.register('services_image_development', ServicesImagesDevelopment);
		ComponentsManager.register('services_image_monitoring', ServicesImagesMonitoring);
		ComponentsManager.register('services_image_seo', ServicesImagesSEO);
		ComponentsManager.register('transition_services', TransitionServices);
	}


};
